export const rowsPerPageOptions = [10, 25];
